import { useBackend } from "../../services";

export const useDeleteGearItem = () => {
  const { deleteRequest } = useBackend();
  const deleteGearItem = (parameters: IDeleteGearItemParameters) =>
    deleteRequest("gearItems", parameters);
  return { deleteGearItem };
};

export interface IDeleteGearItemParameters {
  uuid: string;
}
